import styled from "styled-components";
import NavBar from "../../../Componentes/NavBar";
import BodyWrapper from "./BodyWrapper";
import { useModal } from "../../../contexts/ModalContext";
import SidebarBM from "./SidebarBM";

const Container = styled.div`
    width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    background-color: #242d34;
`

const BoletimMedicao = () => {

    const { isModalOpen, openModal } = useModal();

    const handleSidebarOpen = () => {
        openModal('sidebarBM');
    }

    return(
        <>
            <Container>
                <NavBar navTo="/modulo/controle-medicao/pedidos-compra" changeState={ handleSidebarOpen } />
                <BodyWrapper />
            </Container>
            {
                isModalOpen('sidebarBM') && (
                    <SidebarBM />
                )
            }
        </>
    )
}

export default BoletimMedicao;